import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-editor',
  template: `<div></div>`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MockEditorComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class MockEditorComponent implements ControlValueAccessor {
  disabled: boolean = false;
  onChange = (_: number) => {};
  onTouched = () => {};
  get value(): number {
    return 0;
  }

  writeValue(_: number): void {}

  registerOnChange(fn: (_: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(_: boolean): void {
    this.disabled = false;
  }
}
